import { disciplineArray } from "@/types/api";
import { useTranslations } from "next-intl";

export default function SelectDiscipline({name, className, change, defaultVal, value, disabled, id, empty} : {
    name:string, 
    className: string, 
    change: (e: any) => void,
    defaultVal?:string | undefined,
    value?: string | undefined,
    disabled?: boolean | undefined,
    id?:string,
    empty?:string
}){
    
    const t = useTranslations("discipline")
    empty = empty ?? t("selectDiscipline")

    if(disabled === undefined) disabled=false
    return (
        <select className={className} id={id} disabled={disabled} onChange={change} name={name} value={value} defaultValue={defaultVal}>
            <option value="">{empty}</option>
            {
                Object.values(disciplineArray).map((disc) => (
                    <option key={disc} value={disc}>{t("short." + disc)}</option>
                ))
            }
        </select>
    )
}